import { Toolbar } from 'primereact/toolbar'
import { Toast } from 'primereact/toast'
import { useEffect, useRef, useState } from 'react'
import { Button } from 'primereact/button'
import { useSelector } from 'react-redux'
import donViDangKyDuThiProcessor from '../../processor/donViDangKyDuThiProcessor'
// import hoiDongProcessor from '../../processor/hoiDongProcessor'
import monThiProcessor from '../../processor/monThiProcessor'
import truongProcessor from '../../processor/truongProcessor'
import VanBangSearcher from './VanBangSearcher'
import ViewVanBang from './ViewVanBang'
import ListVanBang from './ListVanBang'
import store from '../../store/store'
import { setDonViDangKyDuThiId, setDonViDangKyDuThis } from '../../store/reducer/donViDangKyDuThi'
import heDaoTaoProcessor from '../../processor/heDaoTaoProcessor'
import hinhThucDaoTaoProcessor from '../../processor/hinhThucDaoTaoProcessor'
import { setHeDaoTaoId, setHeDaoTaos } from '../../store/reducer/heDaoTao'
import { setHinhThucDaoTaoId, setHinhThucDaoTaos } from '../../store/reducer/hinhThucDaoTao'
// import { setHoiDongs } from '../../store/reducer/hoiDong'
import { setMonThis } from '../../store/reducer/monThi'
import { setTruongs } from '../../store/reducer/truong'
import { getGioiTinh } from '../../constant/gioiTinh'

const disabled = [
  'hoTen',
  'cccd',
  'gioiTinh',
  'ngaySinh',
  'noiSinh',
  'danToc',
  'truongId',
  'hanhKiem',
  'hocLuc',
  'ketQua',
  'xepLoai',
  'heDaoTaoId',
  'hinhThucDaoTaoId',
  'donViDangKyDuThiId',
  'hoiDongId',
  'soHieu',
  'soCapBang',
  'khoaThiId',
  'ngayKy',
  'nguoiKy',
  'ngayCapBang',
  'ghiChu',
]

const renderColumn = ({ additionColumn, props }) => {
  const { canEdit, buttons, buttonsAfter, dontShow, chucNangTitle } = props
  const column = [
    { value: 'hoTen', name: 'Họ tên' },
    {
      value: 'gioiTinh',
      name: 'Giới tính',
      render: (item) => getGioiTinh(item.gioiTinh),
    },
    {
      value: 'ngaySinh',
      name: 'Ngày sinh',
    },
    { value: 'soHieu', name: 'Số hiệu' },
    { value: 'soCapBang', name: 'Số cấp bằng' },
    ...additionColumn,
    {
      name: chucNangTitle || 'Chức năng',
      alignHeader: 'center',
      render: (data) => {
        return (
          <div className="flex justify-content-center">
            {buttons && buttons.map((button) => <Button {...button(data)} />)}
            {!dontShow && (
              <ViewVanBang
                data={data}
                disabled={canEdit ? [] : disabled}
                {...props}
                disabledAll={!canEdit}
              />
            )}
            {buttonsAfter && buttonsAfter.map((button) => <Button {...button(data)} />)}
          </div>
        )
      },
    },
  ]
  return column
}

const ListVanBangWithView = (props) => {
  const khoaThiId = useSelector((item) => item.khoaThi.id)

  const { moduleTitle, headerLeft } = props
  let { additionColumn } = props
  additionColumn = additionColumn || []

  const [paging, setPaging] = useState({ skip: 0, take: 10, total: 0 })
  const [datas, setDatas] = useState([])
  const [name, setName] = useState('')
  const toast = useRef()

  const getHeDaoTao = async () => {
    const rs = await heDaoTaoProcessor.getAll()
    store.dispatch(setHeDaoTaos(rs))
  }

  const getHinhThucDaoTao = async () => {
    const rs = await hinhThucDaoTaoProcessor.getAll()
    store.dispatch(setHinhThucDaoTaos(rs))
  }
  const getDonViDK = async () => {
    if (props.getDonViDK) {
      await props.getDonViDK()
    }
    if (khoaThiId) {
      const rs = await donViDangKyDuThiProcessor.getByKhoaThi(khoaThiId)
      store.dispatch(setDonViDangKyDuThis(rs))
    }
  }
  // const getHoiDong = async () => {
  // const rs = await hoiDongProcessor.getByKhoaThi(khoaThiId)
  // store.dispatch(setHoiDongs(rs))
  // }
  const getMonthis = async () => {
    const rs = await monThiProcessor.getAll()
    store.dispatch(setMonThis(rs))
  }
  const getTruong = async () => {
    const rs = await truongProcessor.getAll()
    store.dispatch(setTruongs(rs))
  }

  useEffect(() => {
    getHeDaoTao()
    getHinhThucDaoTao()
    getTruong()
    getMonthis()
    store.dispatch(setDonViDangKyDuThiId(0))
    store.dispatch(setHeDaoTaoId(0))
    store.dispatch(setHinhThucDaoTaoId(0))
  }, [])

  useEffect(() => {
    getDonViDK()
    // getHoiDong()
  }, [khoaThiId])

  return (
    <>
      <Toast ref={toast} />
      <div className="flex flex-column">
        <div className="flex justify-content-between">
          <h4>{moduleTitle}</h4>
          {headerLeft}
        </div>
        <div className="card">
          <Toolbar
            className="mb-4"
            right={
              <div className="flex">
                <VanBangSearcher name={name} setName={setName} {...props} />
              </div>
            }
          />
          <ListVanBang
            column={renderColumn({
              additionColumn,
              props,
            })}
            datas={datas}
            setDatas={setDatas}
            paging={paging}
            setPaging={setPaging}
            name={name}
            {...props}
          />
        </div>
      </div>
    </>
  )
}
export default ListVanBangWithView
